import { sampleIntegrationsMenu } from '@/constants';
import useScreenDimensions from '@/hooks/useScreenDimensions';
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import IntegrationCard from './IntegrationCard';
import TelegramConfigModal from './channels/telegram';
import TwilioConfigModal from './channels/twilio';
import WhatsAppConfigModal from './channels/whatsapp';
import ZohoConfigModal from './channels/zoho';

function IntegrationsMarketplace() {
  const installedIntegrations = sampleIntegrationsMenu.filter(
    (item) => item.installed
  );

  const [configModals, setConfigModals] = useState({
    whatsapp: false,
    telegram: false,
    slack: false,
    hubspot: false,
    twilio: false,
    zoho: false,
  });

  const { width, height } = useScreenDimensions();
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography marginY={3} variant="h6">
        Installed {installedIntegrations.length}/{sampleIntegrationsMenu.length}{' '}
        integrations.
      </Typography>
      <Box display="flex" gap={2} flexDirection="row">
        {installedIntegrations.map((item, index) => (
          <IntegrationCard
            item={item}
            key={index}
            setConfigModals={setConfigModals}
          />
        ))}
      </Box>
      <WhatsAppConfigModal
        openModal={configModals.whatsapp}
        setConfigModals={setConfigModals}
      />
      <TelegramConfigModal
        openModal={configModals.telegram}
        setConfigModals={setConfigModals}
      />
      <TwilioConfigModal
        openModal={configModals.twilio}
        setConfigModals={setConfigModals}
      />
      <ZohoConfigModal
        openModal={configModals.zoho}
        setConfigModals={setConfigModals}
      />
    </Box>
  );
}

export default IntegrationsMarketplace;
